/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { axiosInstance } from "../lib/axios";
import adminService from "../services/admin.service";
import { toast } from "sonner";

export default function AssignCoursePanel({
  userEmail,
  enrollmentId,
  adminEmail,
  membershipTitle,
}) {
  const [courses, setCourses] = useState([]);
  const [list] = useState({ active: [], expired: [] });
  const [courseId, setCourseId] = useState("");
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);

  const category = (membershipTitle || "")
    .toString()
    .replace(/-/g, " ")
    .trim()
    .toLowerCase();

  const loadCourses = async () => {
    const qs = new URLSearchParams({
      limit: "100",
      ...(category ? { category } : {}),
    });
    const { data } = await axiosInstance.get(`/course?${qs}`);
    setCourses(data?.data || data || []);
  };

  useEffect(() => {
    loadCourses();
  }, [userEmail, membershipTitle]);

  const assign = async () => {
    if (!courseId) return;
    setLoading(true);
    try {
      await adminService.assignCourse({
        userEmail,
        courseId,
        enrollmentId: enrollmentId,
        assignedBy: adminEmail || "admin",
        note,
      });
      // await load();
      setCourseId("");
      setNote("");
      toast.success("Course assigned successfully");
    } catch (err) {
      toast.error(`Failed to assign course ${err.response.data.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="rounded-lg border bg-white">
      <div className="px-4 py-3 border-b font-semibold text-sm">
        Assign Course
      </div>

      <div className="p-4 grid gap-3 md:grid-cols-2">
        <div className="col-span-full">
          <label className="text-xs text-slate-600">Course</label>
          <select
            value={courseId}
            onChange={(e) => setCourseId(e.target.value)}
            className="mt-1 w-full rounded border px-3 py-2 text-sm"
          >
            <option value="">
              {category
                ? `Select course in “${membershipTitle}”`
                : "Select course…"}
            </option>
            {courses?.responseObject?.response?.docs?.map((c) => (
              <option key={c._id} value={c._id}>
                {c.title}
              </option>
            ))}
          </select>
        </div>

        <div className="md:col-span-2">
          <label className="text-xs text-slate-600">Note (optional)</label>
          <textarea
            rows={2}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            className="mt-1 w-full rounded border px-3 py-2 text-sm"
            placeholder="Any special instruction…"
          />
        </div>

        <div className="md:col-span-2">
          <button
            onClick={assign}
            disabled={!courseId || loading}
            className="inline-flex items-center rounded-md bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-black disabled:opacity-60"
          >
            {loading ? "Assigning…" : "Assign Course"}
          </button>
        </div>
      </div>

      <div className="px-4 py-3 border-t text-sm font-semibold">
        Current Enrollments
      </div>
      <div className="p-4">
        <table className="w-full text-sm">
          <thead className="text-left text-xs text-slate-500">
            <tr>
              <th className="py-2">Course</th>
              <th className="py-2">Expires</th>
              <th className="py-2">Assigned</th>
              <th className="py-2"></th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {list.active.map((row) => (
              <tr key={row.courseId}>
                <td className="py-2">{row.courseTitle || row.courseId}</td>
                <td className="py-2">
                  {row.expiresAt
                    ? new Date(row.expiresAt).toLocaleDateString()
                    : "—"}
                </td>
                <td className="py-2">
                  <span
                    className={`px-2 py-0.5 rounded text-xs ${
                      row.isAssigned
                        ? "bg-green-100 text-green-700"
                        : "bg-slate-100 text-slate-600"
                    }`}
                  >
                    {row.isAssigned ? "YES" : "NO"}
                  </span>
                </td>
                {/* <td className="py-2 text-right">
                  <button
                    onClick={() => revoke(row.courseId)}
                    className="rounded border px-3 py-1 text-xs hover:bg-slate-50"
                  >
                    Revoke
                  </button>
                </td> */}
              </tr>
            ))}
            {!list.active.length && (
              <tr>
                <td className="py-6 text-center text-slate-500" colSpan={4}>
                  No active courses
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
